<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="等级名称">
                <el-input style="width: 186px;" v-model="queryForm.gradeName"></el-input>
            </el-form-item>
            <el-form-item label='所属店铺'>
                <!-- <el-input v-model='queryForm.shopId'></el-input> -->
                <GridSelectLi style="width: 186px" title="选择店铺" labelName="shopName" labelValue="id"
                              :value="queryForm.shopId" :limit="1" size="small"
                              @getValue="getSeachValueShopId" :columns="SHOP_code" :searchs="SHOP_search" dataListUrl="/mall/shop/findList" entityBeanName="mallShop" queryEntityUrl="/mall/shop/get">
                </GridSelectLi>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getMppGradeList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addMppGrade">新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editMppGrade(null)"
                        >修改</el-button
                    >
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteMppGrade(null)"
                        >删除</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        @click="upgradeRecord"
                        >升级记录</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshMppGradeList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                height='100%'
                :data="mppGradeList"
                row-key="id"
                border
                :header-row-style="{ height: '10px' }"
                :header-cell-style="{ padding: '10px' }"
                :row-style="{ height: '9px' }"
                :cell-style="{ padding: '9px' }"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="gradeName" label="等级名称" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="grade" label="等级数值" width="180">
                </el-table-column>
                <el-table-column align="center" prop="gradeLogo" label="等级logo" width="180">
                    <template slot-scope="scop">
                        <div v-if='scop.row.gradeLogo'>
                            <el-image
                                @click='updateSrcList(scop.row.gradeLogo)'
                                style="width: 30px; height: 30px"
                                :src="scop.row.gradeLogo"
                                :preview-src-list="srcList"
                            > </el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="directNumber" label="直推人数" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="teamNumber" label="团队人数" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="directPerformance" label="直推业绩" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="teamPerformance" label="团队业绩" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="personalPerformance" label="个人业绩" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="distributionRatio" label="分销比例" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="gradeRatio" label="等级比例" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="serviceRatio" label="服务比例" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="discount" label="价格折扣" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="scoreDiscount" label="积分折扣" width="180">
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='shopId'
                    label='所属店铺'
                    width='180'

                >
                    <template slot-scope="scop">
                        <span v-if="scop.row.shop">{{scop.row.shop.shopName}}</span>
                        <span v-else>暂无店铺</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="300">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="viewMppGrade(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">权益</span>
                            </div>
                            <div @click="checkMppGrade(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editMppGrade(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteMppGrade(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="mppGradeStates[mppGradeState]" :visible.sync="showDialog" width="50%" @close="closeDialog">
                <div>
                    <el-form :model="mppGrade" ref="mppGradeForm" :rules="rules" label-width="80px" :inline="true" size="small">
                        <!-- <el-form-item label="等级名称" prop="gradeName">
                            <el-input size="small" v-model="mppGrade.gradeName" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item> -->
                        <el-form-item label='所属店铺' prop="shopId">
                            <!-- <el-input v-model='mppGrade.shopId'></el-input> -->
                            <GridSelectLi style="width: 177px" title="选择店铺" labelName="shopName" labelValue="id"
                                          :value="mppGrade.shopId" :limit="1" size="small" :disabled="mppGradeState == 'check'"
                                          @getValue="getValueShopId" :columns="SHOP_code" :searchs="SHOP_search" dataListUrl="/mall/shop/findList" entityBeanName="mallShop" queryEntityUrl="/mall/shop/get">
                            </GridSelectLi>
                        </el-form-item>
                        <el-form-item label="等级名称" prop="grade">
                            <!-- <el-input size="small" v-model="mppGrade.grade" :disabled="mppGradeState == 'check'"></el-input> -->
                            <el-select
                                style="width: 177px;"
                                v-model='mppGrade.grade'
                                size='small'
                                placeholder='等级名称'
                                :disabled="mppGradeState == 'check'"
                            >
                                <el-option v-for='(item,index) in currencyTypeEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="等级权重" prop="weight">
                            <el-input style="width: 177px;" size="small"
							placeholder="加权分红时使用"
							 v-model="mppGrade.weight" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="升级模式" prop="upgradeMode">
                            <!-- <el-input style="width: 177px;" size="small" v-model="mppGrade.upgradeMode" :disabled="mppGradeState == 'check'"></el-input> -->
                            <el-select
                                style="width: 177px;"
                                v-model='mppGrade.upgradeMode'
                                size='small'
                                placeholder='升级模式'
                                :disabled="mppGradeState == 'check'"
                            >
                                <el-option v-for='(item,index) in upgradeModeTypeEnumList' :label='item.value' :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="支付单元" prop="upgradePayUnit">
                            <!-- <el-input style="width: 177px;" placeholder="请输入升级支付单元" size="small" v-model="mppGrade.upgradePayUnit" :disabled="mppGradeState == 'check'"></el-input> -->
                            <el-select
                                style="width: 177px;"
                                v-model='mppGrade.upgradePayUnit'
                                size='small'
                                placeholder='升级支付单元'
                                :disabled="mppGradeState == 'check'"
                            >
                                <el-option v-for='(item,index) in upgradePayUnitTypeEnumList' :label='item.value'
                                           :value='item.key'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="升级费用" prop="upgradeMoney">
                            <el-input style="width: 177px;" size="small" 
							placeholder="购买升级时的费用"
							v-model="mppGrade.upgradeMoney" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="最多续费" prop="allowMaxUnit">
                            <el-input style="width: 177px;" placeholder="最多允许续费几个单元" size="small" v-model="mppGrade.allowMaxUnit" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="直推人数" prop="directNumber">
                            <el-input style="width: 177px;" size="small"
							 placeholder="对直推人数要求"
							v-model="mppGrade.directNumber" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
						<el-form-item label="直推有效人数" prop="directEffectiveNumber">
						    <el-input style="width: 177px;" size="small"
							 placeholder="对直推人数要求"
							v-model="mppGrade.directEffectiveNumber" :disabled="mppGradeState == 'check'"></el-input>
						</el-form-item>
                        <el-form-item label="间推人数" prop="indirectNumber">
                            <el-input style="width: 177px;" placeholder="对间推人数要求" size="small" v-model="mppGrade.indirectNumber" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="直推业绩" prop="directPerformance">
                            <el-input style="width: 177px;" size="small" 
							placeholder="对直推业绩要求"
							v-model="mppGrade.directPerformance" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="间推业绩" prop="indirectPerformance">
                            <el-input style="width: 177px;" placeholder="对间推业绩要求" size="small" v-model="mppGrade.indirectPerformance" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="个人业绩" prop="personalPerformance">
                            <el-input style="width: 177px;" placeholder="对个人业绩要求" size="small" v-model="mppGrade.personalPerformance" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="团队人数" prop="teamNumber">
                            <el-input style="width: 177px;" placeholder="对团队人数要求" size="small" v-model="mppGrade.teamNumber" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="团队业绩" prop="teamPerformance">
                            <el-input style="width: 177px;" placeholder="对团队业绩要求" size="small" v-model="mppGrade.teamPerformance" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="成长要求" prop="growthValue">
                            <el-input style="width: 177px;" placeholder="对成长值要求" size="small" v-model="mppGrade.growthValue" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="分销比例" prop="distributionRatio">
                            <el-input style="width: 177px;" placeholder="暂时没有使用" size="small" v-model="mppGrade.distributionRatio" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="等级比例" prop="gradeRatio">
                            <el-input style="width: 177px;" placeholder="级差计算时使用" size="small" v-model="mppGrade.gradeRatio" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="服务比例" prop="serviceRatio">
                            <el-input style="width: 177px;" placeholder="暂时没有使用" size="small" v-model="mppGrade.serviceRatio" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="折扣比例" prop="discount">
                            <el-input style="width: 177px;" placeholder="标准商品折扣" size="small" v-model="mppGrade.discount" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="积分折扣" prop="scoreDiscount">
                            <el-input style="width: 177px;" placeholder="积分商品折扣" size="small" v-model="mppGrade.scoreDiscount" :disabled="mppGradeState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="等级logo" prop="gradeLogo">
                            <el-upload
                                action=""
                                :disabled="mppGradeState == 'check'"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :http-request="uploadAvatar"
                            >
                                <img v-if="mppGrade.gradeLogo" :src="mppGrade.gradeLogo" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="mppGradeState != 'check'">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="权益" :visible.sync="exportDialogVisible" width="80%" @close="closeDialog1">
                <GROPEList :product-id="ida" ref="reff"></GROPEList>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog1">关闭</el-button>
                </div>
            </el-dialog>

            <el-drawer
                title="升级记录"
                :visible.sync="viewShow"
                direction="rtl"
                size="70%"
                :before-close="colseupgradeRecord">
                <MppGradeUplog :upgradeModeTypeEnumList="upgradeModeTypeEnumList" ref="shopUse"></MppGradeUplog>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GROPEList from '@/components/organization/MppGradeRights.vue';
import MppGradeUplog from '@/components/organization/MppGradeUplog.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { SHOP, SHOP_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GROPEList,
        MppGradeUplog
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppGradeList();
                this.getMppGradeList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppGradeList();
                this.getMppGradeList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                gradeName: '', //等级名称
                shopId: ''
            },
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppGradeState: 'add',
            mppGradeStates: {
                add: '新建等级',
                check: '查看等级',
                edit: '修改等级'
            },
            currencyTypeEnumList:[],
            upgradeModeTypeEnumList:[],
            upgradePayUnitTypeEnumList:[],
            multipleSelection: [],
            mppGradeList: [],
            mppGrade: {
                id: '', //
                shopId: '',
                gradeName: '', //等级名称
                grade:'', //等级数值
                weight:'', //权重
                gradeLogo: '', //等级logo
                directNumber: '', //直推人数
                directPerformance: '', //直推业绩
                indirectPerformance:'',
                indirectNumber: '',//直播人数要求
                personalPerformance: '', //个人业绩
                teamNumber: '', //团队人数
                teamPerformance: '', //团队业绩
                growthValue:'',
                distributionRatio: '', //分销比例
                gradeRatio: '',//等级比例
                serviceRatio: '', //服务比例
                discount: '', //价格折扣
                scoreDiscount: '', //积分折扣
                upgradeMode: '',// 升级模式
                upgradePayUnit: '', // 升级支付单元
                upgradeMoney: '', // 升级费用 
                allowMaxUnit: '',// 最多允许续费单元
            },
            btnLoading: false,

            rules: {
                gradeName: [{ required: true, message: '等级名称不能为空', trigger: 'blur' }],
                grade: [{ required: true, message: '等级数值不能为空', trigger: 'blur' }],
                weight: [{ required: true, message: '等级权重不能为空', trigger: 'blur' }],
                directNumber: [{ required: true, message: '直推人数不能为空', trigger: 'blur' }],
                directPerformance: [{ required: true, message: '直推业绩不能为空', trigger: 'blur' }],
                indirectNumber: [{ required: true, message: '间推人数要求不能为空', trigger: 'blur' }],
                indirectPerformance: [{ required: true, message: '间推业绩要求不能为空', trigger: 'blur' }],
                personalPerformance: [{ required: true, message: '个人业绩不能为空', trigger: 'blur' }],
                teamNumber: [{ required: true, message: '团队人数不能为空', trigger: 'blur' }],
                teamPerformance: [{ required: true, message: '团队业绩不能为空', trigger: 'blur' }],
                growthValue: [{ required: true, message: '成长值要求不能为空', trigger: 'blur' }],
                distributionRatio: [{ required: true, message: '分销比例不能为空', trigger: 'blur' }],
                gradeRatio: [{ required: true, message: '等级比例不能为空', trigger: 'blur' }],
                serviceRatio: [{ required: true, message: '服务比例不能为空', trigger: 'blur' }],
                discount: [{ required: true, message: '价格折扣不能为空', trigger: 'blur' }],
                scoreDiscount: [{ required: true, message: '积分折扣不能为空', trigger: 'blur' }],
                upgradeMode: [{ required: true, message: '升级模式不能为空', trigger: 'blur' }],
                upgradePayUnit: [{ required: true, message: '升级支付单元不能为空', trigger: 'blur' }],
                upgradeMoney: [{ required: true, message: '升级费用不能为空', trigger: 'blur' }],
                allowMaxUnit: [{ required: true, message: '最多允许续费单元不能为空', trigger: 'blur' }],
                shopId: [{ required: true, message: '所属店铺不能为空', trigger: 'blur' }],
            },
            viewShow: false,
            srcList:[''],//大图预览
            exportDialogVisible: false,
            ida:'',
        };
    },
    created() {
        this.getMppGradeList();
        this.getCurrencyType();
        this.getUpgradeModeType();
        this.getUpgradePayUnitType();
    },
    methods: {
        viewMppGrade(val){
            console.log(this.$refs.reff)
            try {
                this.$refs.reff.init(val);
            } catch (error) {

            }
            this.exportDialogVisible = true;
            this.ida = val
        },
        //获取升级模块
        getUpgradeModeType() {
            get('/mpp/utils/getEnum', {
                enumType: 'upgrade_mode'
            }).then((res) => {
                this.upgradeModeTypeEnumList = res.enumList;
            });
        },
        getSeachValueShopId(val){
            this.queryForm.shopId=val
        },
        getValueShopId(val){
            this.mppGrade.shopId=val
        },
        getUpgradePayUnitType() {
            get('/mpp/utils/getEnum', {
                enumType: 'upgrade_pay_unit'
            }).then((res) => {
                this.upgradePayUnitTypeEnumList = res.enumList;
            });
        },
        //获取currency_type枚举
        getCurrencyType() {
            get('/mpp/utils/getEnum', {
                enumType: 'grade'
            }).then((res) => {
                this.currencyTypeEnumList = res.enumList;
            });
        },
        upgradeRecord(){
            this.viewShow = true;
        },
        colseupgradeRecord(){
            this.viewShow = false;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        updateSrcList(src){
            this.srcList[0] = src
        },
        resetMppGradeList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppGradeList = [];
        },
        resetDialog() {
            this.mppGradeState = 'add';
            this.showDialog = false;
            this.queryForm = {
                gradeName: '', //等级名称
                shopId: ''
            };
            this.getMppGradeList();
        },
        closeDialog1(){
            this.exportDialogVisible = false;
            this.ida = ''
        },
        closeDialog() {
            this.showDialog = false;
            this.mppGrade = {
                id: '', //
                shopId: '',
                gradeName: '', //等级名称
                grade:'', //等级数值
                weight:'', //权重
                gradeLogo: '', //等级logo
                directNumber: '', //直推人数
                directPerformance: '', //直推业绩
                indirectNumber: '',//直播人数要求
                indirectPerformance:'',
                personalPerformance: '', //个人业绩
                teamNumber: '', //团队人数
                teamPerformance: '', //团队业绩
                distributionRatio: '', //分销比例
                gradeRatio: '',//等级比例
                serviceRatio: '', //服务比例
                discount: '', //价格折扣
                scoreDiscount: '', //积分折扣
                upgradeMode: '',// 升级模式
                upgradePayUnit: '', // 升级支付单元
                upgradeMoney: '', // 升级费用 
                allowMaxUnit: '',// 最多允许续费单元
            };
        },
        submitForm() {
            if (this.mppGradeState == 'add') {
                this.$refs.mppGradeForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/grade/add`, { ...this.mppGrade }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGradeList();
                                this.resetDialog();
                            }
                        });
                    }
                });
            } else if (this.mppGradeState == 'edit') {
                this.$refs.mppGradeForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.mppGrade.rights;
                        delete this.mppGrade.updateTime
                        post(`/mpp/grade/edit`, { ...this.mppGrade }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGradeList();
                                this.resetDialog();
                                this.getMppGradeList();
                            }
                        });
                    }
                });
            }
        },
        addMppGrade() {
            this.showDialog = true;
            this.mppGradeState = 'add';
        },
        checkMppGrade(mppGradeId) {
            console.log(mppGradeId);
            this.currentMppGradeId = mppGradeId;

            this.getMppGradeById();
            this.showDialog = true;
            this.mppGradeState = 'check';
        },
        editMppGrade(mppGradeId) {
            console.log('mppGrade', mppGradeId);
            if (mppGradeId) {
                this.currentMppGradeId = mppGradeId;
                this.getMppGradeById();
            } else {
                this.mppGrade = { ...this.mppGrade, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppGradeState = 'edit';
        },
        deleteMppGrade(mppGradeId) {
            let ids = '';
            if (mppGradeId) {
                ids = mppGradeId;
            } else {
                ids = this.multipleSelection.map((mppGrade) => mppGrade.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/grade/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppGradeList();
                            this.getMppGradeList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshMppGradeList() {
            this.resetMppGradeList();
            this.getMppGradeList();
        },
        getMppGradeList(query = {}) {
            this.loading = true;
            get(`/mpp/grade/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppGradeList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        /**
         * logo上传
         */
        uploadAvatar(params) {
            console.log({ params });
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.mppGrade.gradeLogo = res.url;
                    console.log(this.mppGrade.gradeLogo);
                }
            });
        },
        getMppGradeById() {
            get(`/mpp/grade/get`, { id: this.currentMppGradeId }).then((res) => {
                if (res.success) {
                    this.mppGrade = { ...this.mppGrade, ...res.mppGrade };
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppGradeList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppGradeList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 177px;
    height: 177px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 177px;
    text-align: center;
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}
</style>
